// AUTO-GENERATED by backend/scripts/gen_arrival_i18n.py — do not edit by hand.
// 'Your driver is waiting' live arrival screen strings (14 languages).
export const ARRIVAL_STRINGS = {
 "de": {
  "ar_title": "Ihr Chauffeur",
  "ar_waiting": "Ihr Chauffeur wartet auf Sie",
  "ar_enroute": "Ihr Chauffeur ist unterwegs",
  "ar_pending": "Ihr Chauffeur wird in Kürze zugewiesen",
  "ar_pending_sub": "Sobald wir Ihren Fahrer zuweisen, erscheinen hier Name, Fahrzeug und Kennzeichen.",
  "ar_call": "Chauffeur anrufen",
  "ar_whatsapp": "Chauffeur per WhatsApp",
  "ar_car": "Fahrzeug",
  "ar_pickup": "Abholort",
  "ar_when": "Abholzeit",
  "ar_refresh": "Diese Seite aktualisiert sich automatisch",
  "ar_sub": "Live-Status Ihrer Abholung",
  "ar_notfound": "Keine Buchung zu dieser Referenz gefunden.",
  "ar_cancelled": "Diese Buchung wurde storniert.",
  "ar_eta_label": "Ankunft in ca.",
  "ar_live": "Live-Verfolgung aktiv",
  "ar_map_wait": "Warte auf den Fahrerstandort …"
 },
 "en": {
  "ar_title": "Your Chauffeur",
  "ar_waiting": "Your chauffeur is waiting for you",
  "ar_enroute": "Your chauffeur is on the way",
  "ar_pending": "Your chauffeur will be assigned shortly",
  "ar_pending_sub": "As soon as we assign your driver, their name, car and plate will appear here.",
  "ar_call": "Call chauffeur",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "Vehicle",
  "ar_pickup": "Pickup location",
  "ar_when": "Pickup time",
  "ar_refresh": "This page updates automatically",
  "ar_sub": "Live status of your pickup",
  "ar_notfound": "No booking found for this reference.",
  "ar_cancelled": "This booking was cancelled.",
  "ar_eta_label": "Arriving in approx.",
  "ar_live": "Live tracking active",
  "ar_map_wait": "Waiting for the driver's location…"
 },
 "fr": {
  "ar_title": "Votre chauffeur",
  "ar_waiting": "Votre chauffeur vous attend",
  "ar_enroute": "Votre chauffeur est en route",
  "ar_pending": "Votre chauffeur sera attribué sous peu",
  "ar_pending_sub": "Dès que nous attribuons votre chauffeur, son nom, sa voiture et sa plaque apparaîtront ici.",
  "ar_call": "Appeler le chauffeur",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "Véhicule",
  "ar_pickup": "Lieu de prise en charge",
  "ar_when": "Heure de prise en charge",
  "ar_refresh": "Cette page se met à jour automatiquement",
  "ar_sub": "Statut en direct de votre prise en charge",
  "ar_notfound": "Aucune réservation trouvée pour cette référence.",
  "ar_cancelled": "Cette réservation a été annulée.",
  "ar_eta_label": "Arrivée dans environ.",
  "ar_live": "Suivi en direct actif",
  "ar_map_wait": "Attente de la localisation du chauffeur…"
 },
 "it": {
  "ar_title": "Il tuo conducente",
  "ar_waiting": "Il tuo conducente ti sta aspettando",
  "ar_enroute": "Il tuo conducente è in arrivo",
  "ar_pending": "Il tuo conducente sarà assegnato a breve",
  "ar_pending_sub": "Non appena assegniamo il tuo autista, il loro nome, auto e targa appariranno qui.",
  "ar_call": "Chiama il conducente",
  "ar_whatsapp": "WhatsApp conducente",
  "ar_car": "Veicolo",
  "ar_pickup": "Luogo di raccolta",
  "ar_when": "Orario di raccolta",
  "ar_refresh": "Questa pagina si aggiorna automaticamente",
  "ar_sub": "Stato live del tuo prelievo",
  "ar_notfound": "Nessuna prenotazione trovata per questo riferimento.",
  "ar_cancelled": "Questa prenotazione è stata cancellata.",
  "ar_eta_label": "In arrivo in circa.",
  "ar_live": "Tracciamento live attivo",
  "ar_map_wait": "In attesa della posizione del conducente…"
 },
 "es": {
  "ar_title": "Tu Chofer",
  "ar_waiting": "Tu chofer te está esperando",
  "ar_enroute": "Tu chofer está en camino",
  "ar_pending": "Tu chofer será asignado en breve",
  "ar_pending_sub": "Tan pronto como asignemos tu conductor, su nombre, coche y matrícula aparecerán aquí.",
  "ar_call": "Llamar al chofer",
  "ar_whatsapp": "WhatsApp chofer",
  "ar_car": "Vehículo",
  "ar_pickup": "Lugar de recogida",
  "ar_when": "Hora de recogida",
  "ar_refresh": "Esta página se actualiza automáticamente",
  "ar_sub": "Estado en vivo de tu recogida",
  "ar_notfound": "No se encontró ninguna reserva con esta referencia.",
  "ar_cancelled": "Esta reserva fue cancelada.",
  "ar_eta_label": "Llegando en aproximadamente.",
  "ar_live": "Seguimiento en vivo activo",
  "ar_map_wait": "Esperando la ubicación del conductor…"
 },
 "pt": {
  "ar_title": "Seu Chofer",
  "ar_waiting": "Seu chofer está te esperando",
  "ar_enroute": "Seu chofer está a caminho",
  "ar_pending": "Seu chofer será designado em breve",
  "ar_pending_sub": "Assim que designarmos seu motorista, o nome, carro e placa aparecerão aqui.",
  "ar_call": "Ligue para o chofer",
  "ar_whatsapp": "WhatsApp chofer",
  "ar_car": "Veículo",
  "ar_pickup": "Local de coleta",
  "ar_when": "Hora de coleta",
  "ar_refresh": "Esta página se atualiza automaticamente",
  "ar_sub": "Status ao vivo da sua coleta",
  "ar_notfound": "Nenhuma reserva encontrada para esta referência.",
  "ar_cancelled": "Esta reserva foi cancelada.",
  "ar_eta_label": "Chegando em aproximadamente.",
  "ar_live": "Rastreamento ao vivo ativo",
  "ar_map_wait": "Aguardando a localização do motorista…"
 },
 "tr": {
  "ar_title": "Şoförünüz",
  "ar_waiting": "Şoförünüz sizi bekliyor",
  "ar_enroute": "Şoförünüz yolda",
  "ar_pending": "Şoförünüz kısa sürede atanacak",
  "ar_pending_sub": "Şoförünüz atandığında, ismi, aracı ve plakası burada görünecek.",
  "ar_call": "Şoförü ara",
  "ar_whatsapp": "WhatsApp ile şoförü mesajla",
  "ar_car": "Araç",
  "ar_pickup": "Alış yeri",
  "ar_when": "Alış saati",
  "ar_refresh": "Bu sayfa otomatik olarak güncellenir",
  "ar_sub": "Alışınızın anlık durumu",
  "ar_notfound": "Bu referans için rezervasyon bulunamadı.",
  "ar_cancelled": "Bu rezervasyon iptal edildi.",
  "ar_eta_label": "Yaklaşık varış süresi.",
  "ar_live": "Canlı takip aktif",
  "ar_map_wait": "Şoförün konumunu bekliyoruz…"
 },
 "ru": {
  "ar_title": "Ваш шофёр",
  "ar_waiting": "Ваш шофёр ждёт вас",
  "ar_enroute": "Ваш шофёр в пути",
  "ar_pending": "Ваш шофёр будет назначен скоро",
  "ar_pending_sub": "Как только мы назначим вашего водителя, его имя, автомобиль и номер будут здесь.",
  "ar_call": "Позвонить шофёру",
  "ar_whatsapp": "WhatsApp шофёру",
  "ar_car": "Транспортное средство",
  "ar_pickup": "Место встречи",
  "ar_when": "Время.pickup",
  "ar_refresh": "Эта страница обновляется автоматически",
  "ar_sub": "Текущий статус вашегоPickup",
  "ar_notfound": "Бронирование с этим номером не найдено.",
  "ar_cancelled": "Это бронирование было отменено.",
  "ar_eta_label": "Прибытие через примерно.",
  "ar_live": "Активен живой трекинг",
  "ar_map_wait": "Ожидание местоположения водителя…"
 },
 "ar": {
  "ar_title": "سائقك",
  "ar_waiting": "سائقك في انتظارك",
  "ar_enroute": "سائقك في الطريق",
  "ar_pending": "سيتم تعيين سائقك قريبًا",
  "ar_pending_sub": "بمجرد تعيين سائقك، سيظهر هنا اسمه، سيارته ورقم اللوحة.",
  "ar_call": "اتصل بالسائق",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "المركبة",
  "ar_pickup": "موقع الاستلام",
  "ar_when": "وقت الاستلام",
  "ar_refresh": "تقوم هذه الصفحة بالتحديث تلقائيًا",
  "ar_sub": "الحالة الحية لعملية الاستلام الخاصة بك",
  "ar_notfound": "لم يُعثر على حجز لهذا المرجع.",
  "ar_cancelled": "تم إلغاء هذا الحجز.",
  "ar_eta_label": "الوصول في حوالي",
  "ar_live": "تتبع مباشر نشط",
  "ar_map_wait": "بانتظار موقع السائق..."
 },
 "fa": {
  "ar_title": "ش chauffeur شما",
  "ar_waiting": "ش chauffeur شما در انتظار شماست",
  "ar_enroute": "ش chauffeur شما در راه است",
  "ar_pending": "ش chauffeur شما به زودی تعیین خواهد شد",
  "ar_pending_sub": "به محض اینکه راننده شما تعیین شد، نام، خودرو و پلاک او در اینجا نمایش داده خواهد شد.",
  "ar_call": "تماس با chauffeur",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "خودرو",
  "ar_pickup": "محل سوار شدن",
  "ar_when": "زمان سوار شدن",
  "ar_refresh": "این صفحه به طور خودکار به‌روزرسانی می‌شود",
  "ar_sub": "وضعیت زنده سوار شدن شما",
  "ar_notfound": "هیچ رزروئی برای این مرجع پیدا نشد.",
  "ar_cancelled": "این رزرو لغو شده است.",
  "ar_eta_label": "حدودا در حال آمدن",
  "ar_live": "ردیابی زنده فعال است",
  "ar_map_wait": "در حال انتظار برای موقعیت راننده…"
 },
 "hi": {
  "ar_title": "आपकाchauffeur",
  "ar_waiting": "आपकाchauffeur आपका इंतजार कर रहा है",
  "ar_enroute": "आपकाchauffeur रास्ते में है",
  "ar_pending": "आपकाchauffeur जल्द ही सौंपा जाएगा",
  "ar_pending_sub": "जैसे ही हम आपके ड्राइवर को असाइन करते हैं, उनका नाम, गाड़ी और प्लेट यहां दिखाई देंगे।",
  "ar_call": "chauffeur को कॉल करें",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "वाहन",
  "ar_pickup": "पिकअप स्थान",
  "ar_when": "पिकअप समय",
  "ar_refresh": "यह पृष्ठ स्वचालित रूप से अद्यतन होता है",
  "ar_sub": "आपके पिकअप की लाइव स्थिति",
  "ar_notfound": "इस संदर्भ के लिए कोई बुकिंग नहीं मिली।",
  "ar_cancelled": "यह बुकिंग रद्द कर दी गई थी।",
  "ar_eta_label": "लगभग में आ रहा है।",
  "ar_live": "लाइव ट्रैकिंग सक्रिय",
  "ar_map_wait": "ड्राइवर के स्थान का इंतजार कर रहा है…"
 },
 "zh": {
  "ar_title": "您的专车",
  "ar_waiting": "您的专车在等您",
  "ar_enroute": "您的专车正在路上",
  "ar_pending": "您的专车将很快指派",
  "ar_pending_sub": "一旦我们指派了您的司机，他们的名字、车和车牌将会出现在这里。",
  "ar_call": "拨打司机电话",
  "ar_whatsapp": "WhatsApp司机",
  "ar_car": "车辆",
  "ar_pickup": "接载地点",
  "ar_when": "接载时间",
  "ar_refresh": "此页面会自动更新",
  "ar_sub": "您接载的实时状态",
  "ar_notfound": "未找到该参考的预订。",
  "ar_cancelled": "该预订已被取消。",
  "ar_eta_label": "预计到达时间:",
  "ar_live": "实时追踪已激活",
  "ar_map_wait": "正在等待司机位置…"
 },
 "ko": {
  "ar_title": "당신의 chauffeur",
  "ar_waiting": "당신의 chauffeur가 기다리고 있습니다",
  "ar_enroute": "당신의 chauffeur가 가고 있습니다",
  "ar_pending": "곧 당신의 chauffeur가 배정됩니다",
  "ar_pending_sub": "운전자가 배정되는 즉시 이름, 차량 및 번호판이 여기 나타납니다.",
  "ar_call": "chauffeur에게 전화하기",
  "ar_whatsapp": "WhatsApp chauffeur",
  "ar_car": "차량",
  "ar_pickup": "픽업 장소",
  "ar_when": "픽업 시간",
  "ar_refresh": "이 페이지는 자동으로 업데이트됩니다",
  "ar_sub": "픽업의 실시간 상태",
  "ar_notfound": "이 참조에 대한 예약이 없습니다.",
  "ar_cancelled": "이 예약은 취소되었습니다.",
  "ar_eta_label": "약 도착 예정 시간",
  "ar_live": "실시간 추적 활성화",
  "ar_map_wait": "운전자의 위치를 기다리는 중…"
 },
 "ckb": {
  "ar_title": "چاوفێرەکەی تێگەیشتیت",
  "ar_waiting": "چاوفێرەکەی بۆت نیشتەجاوە",
  "ar_enroute": "چاوفێرەکەی لە ڕووداوە",
  "ar_pending": "چاوفێرەکەی تێدا بەرزە",
  "ar_pending_sub": "بەفەرمی کاتێک دراوی تۆ پێشنیاز بکرێت، ناوی، ئۆتۆمبێل و نیشانیان لێرە دەردەخات.",
  "ar_call": "دەنگ بدە بۆ چاوفێر",
  "ar_whatsapp": "WhatsApp چاوفێر",
  "ar_car": "شەوپینەوە",
  "ar_pickup": "شوێنی بەرھمھێنانی",
  "ar_when": "کاتی بەرھمھێنانی",
  "ar_refresh": "ئەم پەیجە بە شێوەی ڕووتی نوێ دەکرێت",
  "ar_sub": "واژووی ژیان لە بەرەوپێشکردنی تۆ",
  "ar_notfound": "هیچ بەرەوپێشکردنێک بۆ ئەم بەشە نییە.",
  "ar_cancelled": "ئەم بەرەوپێشکردنە پەسندکراوە.",
  "ar_eta_label": "پێویستە هەتا کاتی نووسین.",
  "ar_live": "پەیوەندیدانی ژیانی پەیوەندیدانی",
  "ar_map_wait": "بەرز کردنی شوێنی چاوفێر…"
 }
};
